import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_link.scss'

import { Props, AnchorAttributes } from '../utils/types'

export namespace LinkVariantNS {
  export const gray = 'gray'
  export const none = ''
  export const white = 'white'
}

type LinkVariant =
  | typeof LinkVariantNS.gray
  | typeof LinkVariantNS.none
  | typeof LinkVariantNS.white

interface LinkProps extends Props {
  href: string
  variant?: LinkVariant
}

const cx = bind(styles)

const Link = React.forwardRef<HTMLAnchorElement, AnchorAttributes & LinkProps>(
  ({ className, children, variant = LinkVariantNS.none, ...props }, ref) => (
    <a
      ref={ref}
      className={cx(
        'core-link',
        {
          [`core-link--${variant}`]: variant,
        },
        className
      )}
      {...props}
    >
      {children}
    </a>
  )
)

Link.displayName = 'Link'

export default Link
